import { useEffect } from 'react'
import { useThree } from '@react-three/fiber'

import { isMovementBlocked } from '../../store/uiStore'

// ============================================================
// Visuale su touch: trascinando un dito sul canvas la camera ruota
// (sostituisce i PointerLockControls, che su touch non esistono).
// Multi-touch: ogni dito è tracciato per pointerId, così si può
// guardare con un dito mentre l'altro guida il joystick.
// ============================================================

const SENS = 0.0045
// Stessi limiti verticali dei PointerLockControls desktop
// (minPolarAngle 1, maxPolarAngle PI-0.5, convertiti in pitch)
const PITCH_MAX = Math.PI / 2 - 1
const PITCH_MIN = Math.PI / 2 - (Math.PI - 0.5)

export default function TouchLookControls() {
  const { camera, gl } = useThree()

  useEffect(() => {
    camera.rotation.order = 'YXZ'
    const el = gl.domElement
    const last = new Map() // pointerId → ultima posizione del dito

    const onDown = (e) => {
      if (e.pointerType !== 'touch') return
      last.set(e.pointerId, [e.clientX, e.clientY])
    }
    const onMove = (e) => {
      const prev = last.get(e.pointerId)
      if (!prev) return
      const dx = e.clientX - prev[0]
      const dy = e.clientY - prev[1]
      last.set(e.pointerId, [e.clientX, e.clientY])
      // si può guardare anche col prodotto in mano (niente più drag di
      // rotazione prodotto: c'è il pulsante ⟳); blocca solo il carrello
      if (isMovementBlocked()) return
      camera.rotation.y -= dx * SENS
      camera.rotation.x = Math.min(PITCH_MAX, Math.max(PITCH_MIN, camera.rotation.x - dy * SENS))
    }
    const onUp = (e) => last.delete(e.pointerId)

    el.addEventListener('pointerdown', onDown)
    el.addEventListener('pointermove', onMove)
    window.addEventListener('pointerup', onUp)
    window.addEventListener('pointercancel', onUp)
    return () => {
      el.removeEventListener('pointerdown', onDown)
      el.removeEventListener('pointermove', onMove)
      window.removeEventListener('pointerup', onUp)
      window.removeEventListener('pointercancel', onUp)
    }
  }, [camera, gl])

  return null
}
